import {
  toWSDateString,
  useWSModal,
  useWSSnackbar,
  WSButton,
  WSButtons,
  WSElement,
  WSElementProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { PendingWithholdingStatus } from "@wingspanhq/bookkeeping/dist/lib/interfaces";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useMutationUpdatePendingWithholding } from "../../../query/taxes/mutations";

export type ModalCancelPendingWithholdingProps = {
  pendingWithholdingId: string;
  amount: number;
  currency: Currency;
  date: Date | string;
  onClose: (cancelled: boolean) => void;
} & WSElementProps;

export const ModalCancelPendingWithholding: React.FC<
  ModalCancelPendingWithholdingProps
> = ({
  onClose,
  pendingWithholdingId,
  amount,
  currency,
  date,
  ...elementProps
}) => {
  const [updatePendingWithholding, updatePendingWithholdingMeta] =
    useMutationUpdatePendingWithholding();
  const snackbar = useWSSnackbar();

  return (
    <WSElement {...elementProps}>
      <WSText mb="2XL">
        Are you sure you want to cancel this scheduled payment to IRS of{" "}
        {formatMoney(amount, currency, { showSign: false })} from{" "}
        {toWSDateString(date, "monthDayYear")}?
      </WSText>
      <WSText mb="2XL">Once confirmed, this action cannot be undone.</WSText>

      <WSButtons format="modal">
        <WSButton
          destructive
          onAsyncClick={async () => {
            await updatePendingWithholding({
              pendingWithholdingId,
              status: PendingWithholdingStatus.Cancelled
            });

            snackbar.openSnackbar({
              icon: { name: "check" },
              message: "Pending transaction cancelled successfully"
            });

            onClose(true);
          }}
          loading={updatePendingWithholdingMeta.isLoading}
        >
          Cancel transaction
        </WSButton>
        <WSButton.Tertiary onClick={() => onClose(false)}>
          Keep transaction
        </WSButton.Tertiary>
      </WSButtons>
    </WSElement>
  );
};

export const useModalCancelPendingWithholding = () =>
  useWSModal(ModalCancelPendingWithholding, {
    title: "Cancel pending transaction",
    size: "S"
  });
